import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import { Button } from 'foundations-components/transitional/components/Button';
import { apiNameToTrialIds, apiNameToTrialLengthInDays, DEFAULT_TRIAL_DAYS } from '../../../constants/trial';
import { useSignupContext } from '../../../hooks/useSignupContext';
import { getTrackingSourceFromTrackingData } from '../../../utils/productIdentifier';
import { formatPublicExperimentationForQueryParams } from '../../../utils/signupUrl';
import { generateTrialSignupUrl } from '../../../utils/trialUrl';
import { ErrorBoundary, ErrorBoundaryNames } from '../../ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const DirectToTrialButtonBase = props => {
  var _apiNameToTrialLength;
  const {
    'data-test-id': dataTestId,
    'data-selenium-id': dataSeleniumId,
    apiName,
    ctaType = 'trial',
    children,
    eligibleTreatments,
    uiButtonProps,
    trackingData,
    onClick
  } = props;
  const dttSource = getTrackingSourceFromTrackingData(trackingData);
  const trialId = apiNameToTrialIds[apiName];
  const {
    hubsSignupUrl,
    hubsSignupCta
  } = useSignupContext({
    apiName,
    ctaType,
    trackingData
  });
  const trialSignupUrl = useMemo(() => {
    if (!trialId) {
      const error = `Couldn't find trialId for apiName`;
      const extra = {
        apiName,
        apiNameToTrialIds,
        trialId
      };
      Raven.captureException(new Error(error), {
        extra
      });
      console.error(error, extra);
      return null;
    }
    const experimentParams = formatPublicExperimentationForQueryParams(eligibleTreatments);
    return generateTrialSignupUrl({
      trialId,
      dttSource,
      hubsSignupUrl,
      hubsSignupCta,
      uuid: window.__utAnonId,
      experimentParams
    });
  }, [trialId, dttSource, hubsSignupUrl, hubsSignupCta, apiName, eligibleTreatments]);
  if (!trialSignupUrl) return null;
  const handleClick = () => {
    onClick === null || onClick === void 0 || onClick('TRIAL');
  };
  const buttonText = children || /*#__PURE__*/_jsx(FormattedMessage, {
    message: "purchaseMotions.buttons.trial",
    options: {
      count: (_apiNameToTrialLength = apiNameToTrialLengthInDays[apiName]) !== null && _apiNameToTrialLength !== void 0 ? _apiNameToTrialLength : DEFAULT_TRIAL_DAYS
    }
  });
  return /*#__PURE__*/_jsx(Button, Object.assign({
    "data-test-id": dataTestId !== null && dataTestId !== void 0 ? dataTestId : 'start-trial-button',
    "data-selenium-id": dataSeleniumId,
    use: "primary",
    truncate: true,
    truncateStringProps: {
      justifyContent: 'center'
    }
  }, uiButtonProps, {
    href: trialSignupUrl || undefined,
    onClick: handleClick,
    disabled: !trialId || !trialSignupUrl,
    children: buttonText
  }));
};
export const DirectToTrialButton = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: ErrorBoundaryNames.TRIAL_BUTTON,
  children: /*#__PURE__*/_jsx(DirectToTrialButtonBase, Object.assign({}, props))
});